// MICRO-STEP 3.2 — shared color palette.
//
// This is the SAME list, in the SAME order, previously defined only inline
// inside `ProductHunter.jsx` (Background Editor / "Modifica sfondo" →
// swatches, `data-testid="ph-bg-swatch-*"`). Extracted here, unchanged, so
// both the Background Editor and the Retouch Editor's new "Colore" section
// import the exact same constant instead of each keeping their own copy that
// could drift apart over time.
export const BG_PALETTE = [
  "#FFFFFF", "#F5F5F5", "#E5E7EB", "#9CA3AF", "#4B5563", "#000000",
  "#FEF3C7", "#FDE68A", "#FCA5A5", "#EF4444", "#F97316", "#F59E0B",
  "#84CC16", "#22C55E", "#10B981", "#14B8A6", "#06B6D4", "#3B82F6",
  "#6366F1", "#8B5CF6", "#A855F7", "#EC4899", "#F5E1DA", "#1E293B",
];
